import React, { useState } from "react";
import { Layout, Typography, Avatar } from 'antd';
import 'antd/dist/antd.css';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LoginOutlined,
  MenuOutlined
} from '@ant-design/icons';
import SideBar from './SideBar';
import { SidebarData } from './SidebarData';
import { useDispatch } from "react-redux";
import {logout} from '../../redux/auth/actions'
import DrawerMenu from "./DrawerMenu";
const { Header, Content } = Layout;
const { Title } = Typography;

export const Layouts=({ children })=> {

  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(false);
  const itisphone = window.innerWidth <=500;
  const toggle = () => {
    setCollapsed(!collapsed);    
  };
  const height_window = window.innerHeight -68;
  const logoutButton = () => {
    dispatch(logout());
  }
  const onClose = () => {
    setCollapsed(false);
  };
  return (
    <Layout className="site-layout">
      <Header  style={{  position:itisphone? 'fixed':'', zIndex:10, width:"100%", background: '#3c8dbc' }}>
        <label
          onClick={logoutButton}
          style={{ marginRight: -35, float: 'right', color: 'white', cursor: 'pointer' }} >
          <LoginOutlined />
          &nbsp; Log Out
        </label>
        <Title style={{ float: 'left', color: 'white' }} level={2}>
          {itisphone ? <></>: collapsed ? 
            <Avatar style={{ marginLeft: -30 }} src="https://www.disruptunisia.com/logo/5f5a2033cf1df.png"
            /> :
            <div style={{ marginLeft: -30, marginTop:4 }}><label>Robograf</label> </div>  } </Title>
        {
           itisphone ? 
           <MenuOutlined
             style={{ color: 'white', fontSize: 22, marginLeft: -30, marginTop: 5 }}
             onClick={toggle} />  : collapsed ?
            <MenuUnfoldOutlined
              style={{ color: 'white', fontSize: 22, marginLeft: 30, marginTop: 5 }}
              onClick={toggle} /> :
            <MenuFoldOutlined
              style={{ color: 'white', fontSize: 22, marginLeft: 55, marginTop: 5 }}
              onClick={toggle} />
        }


      </Header>
      <Layout>
       {
         itisphone ?  <DrawerMenu onClose={onClose} setcollapsed={setCollapsed} collapsed={collapsed} ></DrawerMenu> :  <SideBar collapsed={collapsed} items={SidebarData} /> 
       }
        <Content
          className="site-layout-background"
          style={{
            margin: itisphone? '60px  0px 2px 2px':'2px 2px',
            padding: 10,
            minHeight: height_window,
          }} >
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

export default Layouts;
